import { createPortal } from "react-dom"

const ModalWrapper = ({ children, onClose, className = "" }) => {
  return createPortal(
    <section className="fixed h-screen overflow-hidden inset-0 z-9999 flex items-start md:items-center justify-center">
      <div className="absolute inset-0 bg-black/40" onClick={onClose} />
      <div className={`relative bg-white ${className}`}>{children}</div>
    </section>,
    document.body
  )
}

export default ModalWrapper
